<template>
    <div
        :data-component="$options.name"
        class="before:block after:block screen-l:grid screen-l:grid-cols-[1fr_970px_minmax(310px,1fr)] screen-xl:grid-cols-[minmax(160px,1fr)_970px_minmax(310px,1fr)] screen-xxl:grid-cols-[minmax(160px,1fr)_1140px_minmax(310px,1fr)]"
    >
        <div
            class="col-start-2 flex justify-between"
            :class="[isScreenL ? 'px-24 py-16' : 'p-16']"
        >
            <template v-if="isScreenL">
                <div
                    v-for="item in truncateKeyInfos(keyInfo)"
                    :key="item.label"
                    :aria-hidden="!isScreenL"
                    class="flex items-center shrink-0 mr-64"
                >
                    <component
                        :is="item.markedRawIconComponent"
                        class="w-24 h-24 shrink-0 mr-16"
                    />
                    <div class="flex flex-col">
                        <span class="text-text-l font-bold">{{ item.value }} </span>
                        <span class="text-dovegray">{{ item.label }} </span>
                    </div>
                </div>
            </template>
            <div class="flex w-full justify-end">
                <ms-like-button
                    class="mr-16"
                    :decoratedEstate="estate"
                    :componentId="componentId"
                />
                <ms-detail-contact-btn-group
                    class="w-full items-center screen-l:w-auto"
                    :exposeeId="exposeeId"
                    :contact="contact"
                    :position="ContactBtnPosition.STICKY_BAR"
                    :stickyBarBottom="!isScreenL"
                    :componentId="componentId"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./MsDetailStickyBar.ts" />
